/**
 * Logger utility that suppresses all console output in production.
 * In development, sanitizes CRLF characters to prevent log injection (CWE-117)
 * before passing through to the native console methods.
 *
 * Usage:
 *   import logger from '../utils/logger'
 *   logger.error('Something failed:', error)
 *   logger.warn('Unexpected state:', data)
 */

const isDev =
  (window._env_?.REACT_APP_ENV || process.env.REACT_APP_ENV || 'development') !== 'production'

const noop = () => {}

const sanitizeArg = (arg) => {
  if (typeof arg === 'string') return arg.replace(/[\r\n]+/g, ' ')
  if (arg instanceof Error) {
    const sanitized = new Error(arg.message?.replace(/[\r\n]+/g, ' '))
    sanitized.stack = arg.stack?.replace(/[\r\n]+/g, ' ')
    return sanitized
  }
  return arg
}

const createSafeLogger = (method) =>
  isDev ? (...args) => method(...args.map(sanitizeArg)) : noop

const logger = {
  log: createSafeLogger(console.log),
  error: createSafeLogger(console.error),
  warn: createSafeLogger(console.warn),
  debug: createSafeLogger(console.debug),
  info: createSafeLogger(console.info),
}

export default logger
